// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-mcq-progress-card {
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
  box-shadow: 0 0 24px #0000000A !important;
  border-radius: 8px !important;
  opacity: 1;
  width: 100% !important;
  max-width: 964px;
  min-height: 205px;
  height: auto;
}

.new-mcq-progress-card .ant-card-body {
  padding: 0 !important
}

.new-mcq-step-wrapper .ant-steps-label-vertical .ant-steps-item {
  width: 27%;
}

@media only screen and (max-width: 1380px) {
  .new-mcq-step-wrapper .ant-steps-label-vertical .ant-steps-item {
    width: 18%;
  }
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/progressBar/components/progressCard/index.css"],"names":[],"mappings":"AAAA;EACE,0DAA0D;EAC1D,yCAAyC;EACzC,6BAA6B;EAC7B,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".new-mcq-progress-card {\n  background: #FFFFFF 0% 0% no-repeat padding-box !important;\n  box-shadow: 0 0 24px #0000000A !important;\n  border-radius: 8px !important;\n  opacity: 1;\n  width: 100% !important;\n  max-width: 964px;\n  min-height: 205px;\n  height: auto;\n}\n\n.new-mcq-progress-card .ant-card-body {\n  padding: 0 !important\n}\n\n.new-mcq-step-wrapper .ant-steps-label-vertical .ant-steps-item {\n  width: 27%;\n}\n\n@media only screen and (max-width: 1380px) {\n  .new-mcq-step-wrapper .ant-steps-label-vertical .ant-steps-item {\n    width: 18%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
